module.exports = __webpack_public_path__ + "static/img/raw_1523956664.d65a8b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_1523956664.jpg
// module id = 6LsW
// module chunks = 1